var React = require('react');

function Clear (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 3C12.402 3 3 12.402 3 24s9.402 21 21 21 21-9.402 21-21S35.598 3 24 3zM0 24C0 10.746 10.746 0 24 0s24 10.746 24 24-10.746 24-24 24S0 37.254 0 24zm13.937-10.06a1.5 1.5 0 012.122 0l7.94 7.939 7.938-7.94a1.5 1.5 0 112.122 2.122L26.12 24l7.94 7.94a1.5 1.5 0 11-2.12 2.12L24 26.122l-7.94 7.94a1.5 1.5 0 11-2.12-2.122L21.877 24l-7.94-7.94a1.5 1.5 0 010-2.12z"}));
}

Clear.defaultProps = {"viewBox":"0 0 49 48"};

module.exports = Clear;

Clear.default = Clear;
